module.exports = __webpack_public_path__ + "img/course-certificate.2ca36aed.png";